module.exports = __webpack_public_path__ + "593888d553e47017f489f119b2076774.svg";